import { Radio } from 'antd';
import styled from 'styled-components';

export const RadioTextPillItem = styled(Radio.Button)`
  &&&& {
    color: unset;
    display: inline-flex;
    width: fit-content;
    margin: 4px;
    padding: 6px 12px;
    border-radius: 100px;
    border: none;
    font-size: ${({ theme }) => theme.font.size.sm}px;
    background-color: ${({ theme }) => theme.color.grey.grey4};

    span {
      padding: 0;
      line-height: 20px;
      letter-spacing: 0.5px;
    }

    .ant-radio-button-checked,
    :hover {
      border-radius: 100px;
      border: none;
      background-color: ${({ theme }) => theme.color.theme.lighter};
    }

    ::before {
      display: none;
    }

    .ant-radio {
      display: none;
    }
  }
`;
